import styled from 'styled-components';
import { ApCheckbox, colors } from '@alixpartners/ui-components';

interface ICheckboxWrapperProps {
  disabled?: boolean;
}

export const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 31px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
  display: flex;
`;

export const Subtitle = styled.div`
  margin-left: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.3px;
  color: ${colors.grey5};
  display: flex;
  align-items: flex-end;

  span {
    line-height: initial;
    padding-bottom: 5px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const OptionsWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 10px 0 16px;
  background-color: ${colors.grey3};
`;

export const CheckboxWrapper = styled.div<ICheckboxWrapperProps>`
  padding: 1px 6px 0 15px;

  span + span {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: ${({ disabled }) =>
      disabled ? `${colors.grey5}` : `${colors.grey8}`};
    padding-left: 16px !important;
    cursor: ${({ disabled }) => (disabled ? `not-allowed` : `pointer`)};
  }
`;

export const StyledCheckbox = styled(ApCheckbox)`
  min-width: 18px;
`;
